import { render, staticRenderFns } from "./VideoThumbnailDetail.vue?vue&type=template&id=d0c01da4&scoped=true&lang=pug"
import script from "./VideoThumbnailDetail.vue?vue&type=script&lang=js"
export * from "./VideoThumbnailDetail.vue?vue&type=script&lang=js"
import style0 from "./VideoThumbnailDetail.vue?vue&type=style&index=0&id=d0c01da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c01da4",
  null
  
)

export default component.exports